import React from "react";
import { graphql } from "gatsby";
import { getParagraph } from "../../../utils/paragraphHelpers";
import { Col, Container, Row } from "react-bootstrap";
import "./paraKeyPublications.scss";
import ExtractRichText from "../../molecules/ExtractRichText";
import classNames from "classnames";

export const ParagraphKeyPublications = ({ node }) => {
  const paragraphs =
    node?.relationships?.field_key_publication?.map(getParagraph);

  // apply padding & margin has been introduced considering unwanted extra space sometimes
  // depending on the following conditions
  let extraClasses = classNames({
    "apply-padding":
      node?.field_background_color && node?.field_background_color !== "white",
    "apply-margin":
      node?.field_background_color && node?.field_background_color == "white",
  });

  return (
    <>
      {paragraphs && (
        <div
          className={`para-key-publications bg-clr-${node?.field_background_color} ${extraClasses}`}
        >
          <Container className="general-container">
            {node?.field_component_title && (
              <h2 className="para-key-publications__title">
                {node?.field_component_title}
              </h2>
            )}
            {node?.field_body_text && (
              <ExtractRichText
                richText={node?.field_body_text?.value}
                extraClasses="mb-4"
              />
            )}
            <Row className="row-gap-5">
              {paragraphs?.map((paragraph, i) => {
                return (
                  <Col xs={12} md={6} xl={4} key={i}>
                    {paragraph}
                  </Col>
                );
              })}
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export const fragment = graphql`
  fragment ParagraphKeyPublications on paragraph__key_publications {
    id
    field_background_color
    field_component_title
    field_body_text {
      value
    }
    relationships {
      field_key_publication {
        publicationType: __typename
        ...ParagraphNodeExpertOpinion
        ...ParagraphNodeMediaCentre
        ...ParagraphNodePublication
        ...ParagraphNodeGoodPractice
        ...ParagraphNodeShorthand
        ...ParagraphNodeEvents
        ...ParagraphNodePartnerSpotlight
        ...ParagraphNodeFeaturesIframe
        ...ParagraphNodeCountryProfile
      }
    }
  }
`;

export default ParagraphKeyPublications;
